import {
  Button,
  ButtonGroup,
  IconButton,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
} from '@chakra-ui/react';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import SparkelIcon from 'src/components/common/icon/SparkelIcon';

export type Props = {
  pageNumber: number;
  numberOfPages: number;
  setPageNumber: (pageNumber: number) => void;
};

export function Pagination({
  pageNumber,
  numberOfPages,
  setPageNumber,
}: Props) {
  const { t } = useTranslation('project');

  return (
    <ButtonGroup size="xs" mr={2}>
      <IconButton
        icon={<SparkelIcon icon={faChevronLeft} />}
        variant="solid-no-transparent"
        aria-label="Go to previous page"
        colorScheme="gray"
        isDisabled={pageNumber === 1}
        onClick={() => setPageNumber(pageNumber - 1)}
      />
      <Menu>
        <MenuButton
          as={Button}
          colorScheme="gray"
          variant={'solid-no-transparent'}
          isDisabled={numberOfPages === 1}
        >
          {t('viewer-interactions.page')} {pageNumber} / {numberOfPages}
        </MenuButton>
        <MenuList>
          <MenuOptionGroup type="radio" value={`${pageNumber}`}>
            {[...Array(numberOfPages)].map((_, i) => (
              <MenuItemOption
                key={`sheets-viewer-v2-page-${i + 1}`}
                value={`${i + 1}`}
                onClick={() => setPageNumber(i + 1)}
              >
                {t('viewer-interactions.page')} {i + 1}
              </MenuItemOption>
            ))}
          </MenuOptionGroup>
        </MenuList>
      </Menu>
      <IconButton
        icon={<SparkelIcon icon={faChevronRight} />}
        variant="solid-no-transparent"
        colorScheme="gray"
        aria-label="Go to next page"
        isDisabled={pageNumber === numberOfPages}
        onClick={() => setPageNumber(pageNumber + 1)}
      />
    </ButtonGroup>
  );
}
